import React, { Component } from 'react';

export default class ShowNotification extends Component{
    render(){
        return(
            <div id='showNotify' class='showNotify-pivot'></div>
        )
    }
}